import { render } from "./ReportDriverJourney.vue?vue&type=template&id=4f892580"
import script from "./ReportDriverJourney.vue?vue&type=script&lang=js"
export * from "./ReportDriverJourney.vue?vue&type=script&lang=js"
script.render = render

export default script